import {
    attachEventToPromocode,
    attachTicketToPromocode,
    deletePromocodesResource,
    detachEventFromPromocode,
    detachTicketFromPromocode,
    exportPromocodesToExcel,
    getPromocodesResource,
    getPromocodesResources,
    importPromocodesToExcel,
    templatePromocodesToExcel
} from "@/services/PromocodesService/PromocodesService.methods";
import {
    createPromocodeResource,
    getUserResource,
    updatePromocodeResource,
} from "@/views/Admin/Events/Event/Promocodes/Promocode/Promocode.methods";

export const PromocodesService = {
    GetList: getPromocodesResources,
    Get: getPromocodesResource,
    Create: createPromocodeResource,
    Update: updatePromocodeResource,
    Delete: deletePromocodesResource,
    Event: {
        Attach: attachEventToPromocode,
        Detach: detachEventFromPromocode
    },
    Tickets: {
        Attach: attachTicketToPromocode,
        Detach: detachTicketFromPromocode,
    },
    Excel: {
        Export: exportPromocodesToExcel,
        Import: importPromocodesToExcel,
        Template: templatePromocodesToExcel,
    },
    getUser: getUserResource
};
